<template>
	<div class="container section">
		<div
			class="text-module"
			:class="{ 'text-module__text--center': content.textCenter }"
			:style="cssVars"
			v-html="content.content"
		></div>
	</div>
</template>

<script>
export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		cssVars() {
			return {
				'--text-width': this.textWidth + 'px',
			}
		},

		textWidth() {
			switch (this.content.textWidth) {
				case 'small':
					return 560
				case 'medium':
					return 720
				case 'large':
					return 900
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/utils/_mixins.scss';
@import '@/styles/base/_variables.scss';
.text-module {
	width: 100%;
	max-width: var(--text-width) !important;
	margin: auto;
	@include respond-below('phone') {
		max-width: 307px !important;
		h2 {
			font-size: 24px !important;
		}
	}
	&__text {
		&--center {
			text-align: center;
		}
	}
	&--left {
		float: left;
		width: 80% !important;
	}
	&--center {
		margin: auto;
	}
	&--right {
		float: right;
		width: 50% !important;
	}
}
</style>
